const rooster = {
  description: {
    textAlign: 'right',
    fontWeight: 'bold',
    fontSize: '0.9em',
    color: '#ffb900',
  },
  blank_description: {
    fontWeight: 'bold',
  },
  offset: {
    fontWeight: 'bold',
  },
}

const tops = {
  description: {
    textAlign: 'right',
    fontWeight: 'bold',
    fontSize: '0.9em',
    color: '#1672fb',
  },
  blank_description: {
    fontWeight: 'bold',
  },
  offset: {
    fontWeight: 'bold',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Settings/styles/EditorHeader.js